import { Platform } from '@ionic/angular';
import { NotificationService } from 'app/services/notification.service';
import { Component, Input, OnInit } from '@angular/core';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { Subscription } from 'rxjs';
import { Constants } from 'app/utility/constants';

@Component({
    selector: 'app-notification-badge',
    templateUrl: './notification-badge.component.html',
    styleUrls: ['./notification-badge.component.scss'],
    standalone: false
})
export class NotificationBadgeComponent implements OnInit
{

	constructor
		(
			private notificationService: NotificationService,
			private platform: Platform,
			private badge: Badge
		) { }

	@Input() showNumbers: boolean = false;
	@Input() redBadge: boolean = true;
	loading: boolean = false;
	notifications: number;
	notificationsRounded: string;
    public subscription: Subscription;
	ngOnInit()
	{
		this.loading = true;

		this.notificationService.notificationMessage.subscribe(
            (message) => {
                // console.log("notification count received ", message);
                this.setNotificationCount(message);
            }
		);
		setTimeout(() => {
			this.notificationService.getCachedCount().subscribe(
				countresult =>
				{
					this.notificationService.setLocalNotificationCount(countresult);
					this.loading = false;
				}
			);
		}, 2000);
	}

	ngOnDestroy()
	{
		if (this.subscription) { this.subscription.unsubscribe(); }
	}

	setNotificationCount(count:number) {
		this.loading = true;
		this.notifications = count;
		this.notificationsRounded = count+'';
		if (count>99) {
			this.notificationsRounded = "99+";
		}
		this.setNativeFlag();
		setTimeout(() =>
		{
			this.loading = false;
		}, 250);
	}

	setNativeFlag() {
		if (this.platform.is('cordova'))
		{
			// console.log("Setting app badge", this.notifications)
			this.badge.set(this.notifications);
		}
		else {
			// console.log("Not able to set app badge as is not native");
		}
	}
}
